export interface PossibleTypesResultData {
  possibleTypes: {
    [key: string]: string[];
  };
}
const result: PossibleTypesResultData = {
  possibleTypes: {
    Update: [
      'MoodUpdate',
      'StatusUpdate',
      'FastGoalReachedUpdate',
      'UnknownUpdate',
    ],
    Post: ['ActivePost', 'DeletedPost'],
    ResourceList: [
      'Observation',
      'Patient',
      'Procedure',
      'Questionnaire',
      'QuestionnaireResponse',
    ],
    MoodV2: ['OfficialMood', 'CustomMood'],
    Notification: [
      'PostReplyNotification',
      'CircleAdminPostNotification',
      'InappropriatePostNotification',
      'PrivatePostNotification',
      'ReactionNotification',
      'UpdateCommentNotification',
      'UpdateLikeNotification',
      'TagInUpdateNotification',
      'SentPrivateUpdateNotification',
      'CircleAnnouncementNotification',
      'SurveyAssignedNotification',
      'OpenPillarNotification',
      'EngagementNotification',
      'HomeScreenNotification',
      'SubscribedToCircleNotification',
      'FollowerNotification',
      'WeeklyWinnersPostNotification',
      'ChallengeStartedPostNotification',
      'ChallengeWinnersPostNotification',
      'ChallengeRaffleWinnersPostNotification',
    ],
    AppStoreApplication: ['AppStoreWebApplication'],
    TileBehavior: [
      'LaunchUrlTileBehavior',
      'WebAppletTileBehavior',
      'SkillSpringTileBehavior',
    ],
    Video: ['ActiveVideo'],
    RemoveFromManagingGroupUnion: [
      'RemoveFromManagingGroupResult',
      'RemovingOnlyAdminNotAllowed',
    ],
    InvitationOperationsAcceptResult: ['Circle', 'NoOp'],
    AcceptInvitationResult: [
      'CircleInviteResult',
      'OrgInviteResult',
      'AdminInviteResult',
      'InviteDoesNotExist',
      'InvitationAlreadyAccepted',
      'InviteRequiresAccountCustomAuthentication',
    ],
    RejectInvitationResult: ['RejectResult', 'InviteDoesNotExist'],
    RequestEmailChangeResponse: [
      'RequestEmailChangeSuccess',
      'EmailAlreadySetError',
      'UserTypeNotAllowedError',
    ],
    ConfirmEmailChangeResponse: ['ConfirmEmailChangeSuccess'],
  },
};
export default result;
